module.exports = __webpack_public_path__ + "img/adjustment_icon.9b14bc49.svg";